
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiLivelliDialog extends Serenity.EntityDialog<ProdottiLivelliRow, any> {
        protected getFormKey() { return ProdottiLivelliForm.formKey; }
        protected getIdProperty() { return ProdottiLivelliRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiLivelliRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiLivelliRow.nameProperty; }
        protected getService() { return ProdottiLivelliService.baseUrl; }
        protected getDeletePermission() { return ProdottiLivelliRow.deletePermission; }
        protected getInsertPermission() { return ProdottiLivelliRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiLivelliRow.updatePermission; }

        protected form = new ProdottiLivelliForm(this.idPrefix);

    }
}